import * as React from "react";

function CemexIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 95 28"
    >
      <defs>
        <clipPath>
          <rect width="95" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-cemex)">
        <path
          data-name="Path 7086"
          d="M-27.687-5.672l3.266.494A8.376,8.376,0,0,1-27.29-1.123a7.371,7.371,0,0,1-4.479,1.4,5.882,5.882,0,0,1-4.517-1.74A7.128,7.128,0,0,1-37.914-6.51a11.033,11.033,0,0,1,1.09-4.915A8,8,0,0,1-33.8-14.835a7.926,7.926,0,0,1,4.211-1.182,6.087,6.087,0,0,1,4.136,1.37,5.606,5.606,0,0,1,1.858,3.733l-3.1.3a3.3,3.3,0,0,0-.994-1.993,2.95,2.95,0,0,0-1.96-.618,4.289,4.289,0,0,0-2.508.816,5.517,5.517,0,0,0-1.864,2.551,9.219,9.219,0,0,0-.7,3.464,4.281,4.281,0,0,0,.908,2.922,2.89,2.89,0,0,0,2.261,1.031,3.663,3.663,0,0,0,2.3-.816A4.839,4.839,0,0,0-27.687-5.672ZM-22.768,0l3.287-15.748H-7.8l-.548,2.632h-8.433l-.752,3.577h8.153l-.548,2.632h-8.153l-.988,4.275h9.163L-10.468,0ZM1.4,0H-1.67L-2.24-13.159-4.743,0H-7.665l3.287-15.748H.242L.725-4.716,6.1-15.748h4.673L7.471,0H4.517l3.1-13.062Zm9.711,0L14.4-15.748H26.076l-.548,2.632H17.1l-.752,3.577H24.5l-.548,2.632H15.8l-.988,4.275h9.163L23.412,0ZM28.847,0H24.658l6.95-7.971L27.7-15.748h3.384l1.536,2.954q.075.161,1.053,2.181a2.233,2.233,0,0,1,.14.29q1.311-1.6,2.2-2.621l2.481-2.8h4.071L35.357-7.455,39.235,0H35.583L34.4-2.374q-.924-1.88-1.225-2.7a33.446,33.446,0,0,1-2.159,2.621Z"
          transform="translate(44 22)"
          fill="#1330d3"
        />
      </g>
    </svg>
  );
}

export default CemexIcon;
